export default __webpack_public_path__ + "static/media/QIs-Overview.dc472b34.jpeg";